function DashboardHeader({ username = "" }) {
  const greeting = getGreeting();

  return (
    <section style={containerStyle}>
      <p style={greetingStyle}>{greeting}</p>

      <h1 style={titleStyle}>
        Welcome back{username ? `, ${username}` : ""}.
      </h1>

      <p style={subtitleStyle}>
        Here's what's happening in the MyBuildID community today.
      </p>
    </section>
  );
}

function getGreeting() {
  const hour = new Date().getHours();

  if (hour < 12) return "☀️ Good Morning";
  if (hour < 18) return "🌤 Good Afternoon";
  return "🌙 Good Evening";
}

const containerStyle = {
  marginBottom: "28px",
};

const greetingStyle = {
  margin: 0,
  color: "#e10600",
  fontSize: "12px",
  fontWeight: "700",
  textTransform: "uppercase",
  letterSpacing: "1px",
};

const titleStyle = {
  margin: "8px 0",
  fontSize: "42px",
  fontWeight: "800",
  lineHeight: "1.05",
};

const subtitleStyle = {
  margin: 0,
  color: "#9a9a9a",
  fontSize: "16px",
  lineHeight: "1.6",
};

export default DashboardHeader;